import * as z from "zod";

export function isOmsMutationResult(
  toolName: string,
  output: unknown,
): boolean {
  let value: unknown = output;
  if (typeof output === "string") {
    try {
      value = JSON.parse(output);
    } catch {
      value = output;
    }
  }

  switch (toolName) {
    case "create-views":
      return z
        .object({
          created: z.array(z.object({ viewId: z.string().min(1) })).min(1),
        })
        .safeParse(value).success;
    case "create-folder":
      return z.object({ folderId: z.string().min(1) }).safeParse(value).success;
    case "update-view":
      return z.object({ viewId: z.string().min(1) }).safeParse(value).success;
    case "create-packing-slip-template":
    case "update-packing-slip-template":
      return z.object({ id: z.string().min(1) }).safeParse(value).success;
    case "upsert-parcel":
      return z
        .object({
          name: z.string().min(1),
          parcelType: z.enum(["carrier", "custom"]),
        })
        .safeParse(value).success;
    case "workstation_tool":
      return z.object({ success: z.literal(true) }).safeParse(value).success;
    case "publish_automation":
      return (
        typeof value === "string" &&
        value.startsWith("Automation ") &&
        (value.includes(" published successfully ") ||
          value.includes(" updated successfully "))
      );
    case "set_automation_enabled":
      return (
        typeof value === "string" &&
        /^Automation (enabled|disabled) \(flowId:/.test(value)
      );
    default:
      return false;
  }
}
